export class SetLoggedIn {
  public static readonly type = '[Auth] set logged in';
  constructor(public payload: { loggedIn: boolean }) {}
}

export class SetAuthToken {
  public static readonly type = '[Auth] set auth token';
  constructor(public payload: { authToken: string }) {}
}

export class SetCustomerId {
  public static readonly type = '[Auth] set customer id';
  constructor(public payload: { customerId: string }) {}
}

export class SetUserName {
  public static readonly type = '[Auth] set user name';
  constructor(public payload: { userName: string }) {}
}

export class LogoutUser {
  public static readonly type = '[Auth] logout user';
}
